export default class MapZoomDetector
{
	constructor(map, onZoomIn, onZoomOut, customZoomInButton = null, customZoomOutButton = null, interval = 500)
	{ // interval in milliseconds
		this.map = map;

		this.onZoomIn = onZoomIn;
		this.onZoomOut = onZoomOut;

		this.customZoomInButton = customZoomInButton;
        this.customZoomOutButton = customZoomOutButton;

		this.initialDistance = null;
		this.zoomDebounceTimer = null;
		this.interval = interval;

		this.addTouchEventListeners();
		this.addButtonEventListeners();
		this.addMouseWheelEventListener();
	}

	addTouchEventListeners()
	{
		const mapContainer = this.map.getContainer();

		mapContainer.addEventListener('touchstart', (e) =>
		{
			if (e.touches.length === 2)
			{
				this.initialDistance = this.getDistanceBetweenTouches(e);
			}
		});

		mapContainer.addEventListener('touchmove', (e) =>
		{
			if (e.touches.length === 2 && this.initialDistance !== null)
			{
				let currentDistance = this.getDistanceBetweenTouches(e);
				let isZoomingIn = currentDistance > this.initialDistance;
				this.triggerZoomEvent(isZoomingIn);
				this.initialDistance = currentDistance;
			}
		});

		mapContainer.addEventListener('touchend', () =>
		{
			this.initialDistance = null;
			clearTimeout(this.zoomDebounceTimer); // Reset debounce timer on touch end
		});
	}

	addButtonEventListeners()
	{
		// Use custom buttons if provided, otherwise use built-in buttons
		const zoomInButton = this.customZoomInButton || this.map.zoomControl._zoomInButton;
		const zoomOutButton = this.customZoomOutButton || this.map.zoomControl._zoomOutButton;

		zoomInButton.addEventListener('click', () => this.triggerZoomEvent(true));
		zoomOutButton.addEventListener('click', () => this.triggerZoomEvent(false));
	}

	addMouseWheelEventListener()
	{
		const mapContainer = this.map.getContainer();
		mapContainer.addEventListener('wheel', (e) =>
		{
			let isZoomingIn = e.deltaY < 0;
			this.triggerZoomEvent(isZoomingIn);
		});
	}

	getDistanceBetweenTouches(e)
	{
		const touch1 = e.touches[0];
		const touch2 = e.touches[1];
		return Math.sqrt(Math.pow(touch2.pageX - touch1.pageX, 2) + Math.pow(touch2.pageY - touch1.pageY, 2));
	}

	triggerZoomEvent(isZoomingIn)
	{
		// Debounce zoom event
		if (this.zoomDebounceTimer)
		{
			return;
		}
		this.zoomDebounceTimer = setTimeout(() =>
		{
			this.zoomDebounceTimer = null;
		}, this.interval);

		const zoomLevel = this.map.getZoom();
		if (isZoomingIn)
		{
			this.onZoomIn(zoomLevel, zoomLevel + 1);
		} else
		{
			this.onZoomOut(zoomLevel, zoomLevel - 1);
		}
	}
}
